module.exports = __webpack_public_path__ + "img/zhizao.fa83f6f1.png";